import React from 'lib/react';
import {
  EVChip,
  EVGrid,
  EVTypography,
} from 'lib/components';
import clsx from 'lib/clsx';
import { formatAddress } from 'features/order/Order.utils';
import { useTranslation } from 'lib/translation';
import PropTypes from 'prop-types';
import BuildingDetailsListItemStyles from './BuildingDetailsListItemStyles';

function BuildingDetailsListItem(props) {
  const { t } = useTranslation();
  const {
    address,
    building,
    isFocused,
    isComplex,
    index,
    handleClick,
  } = props;
  const classes = BuildingDetailsListItemStyles({ index });

  const handleKeyDown = (e) => e.key === 'Enter' && handleClick(e);

  return (
    <EVGrid
      className={clsx(classes.buildingDetails, isFocused && 'focused')}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      data-testid={`property-details-${index}`}
      tabindex="0"
    >
      <EVTypography display="inline" className={classes.propertyTypeHeading}>{t('BuildingId')}</EVTypography>
      {(building || isComplex) && <EVChip label={building || index + 1} className={classes.buildingIdChip} />}
      <EVTypography className={classes.buildingDetailsAddress}>
        {formatAddress(address)}
      </EVTypography>
    </EVGrid>
  );
}

BuildingDetailsListItem.defaultProps = {
  building: null,
};

BuildingDetailsListItem.propTypes = {
  address: PropTypes.shape().isRequired,
  building: PropTypes.string,
  isFocused: PropTypes.bool.isRequired,
  isComplex: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default BuildingDetailsListItem;
